<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Adicionar Participantes na Arrecadação</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col md="6">
            <v-text-field
              label="Arrecadação"
              :value="fields.fundraising_id.name"
              type="text"
              disabled
              outlined dense
            ></v-text-field>
            <decimal-number
              label="Valor total"
              v-model="fields.amount_to_pay.value"
              :rules="[...fields.amount_to_pay.apiErrors]"
              outlined dense
            ></decimal-number>
            <v-autocomplete
              label="Forma de pagamento"
              v-model="fields.method.value"
              :rules="[...fields.method.rules, ...fields.method.apiErrors]"
              :items="methodOptions"
              outlined dense
            ></v-autocomplete>
            <v-autocomplete v-if="!fields.method.value && fields.method.value !== 'monthly'"
              label="Em quais meses?"
              v-model="fields.period.value"
              :rules="[...fields.period.rules, ...fields.period.apiErrors]"
              :items="periodOptions"
              outlined dense
            ></v-autocomplete>
            <v-text-field
              :label="'Quantidade de parcelas (máx: ' + fields.number_of_installment.max + ' parcelas)'"
              v-model="fields.number_of_installment.value"
              :rules="[...fields.number_of_installment.rules, ...fields.number_of_installment.apiErrors]"
              type="number"
              @input="fields.number_of_installment.apiErrors = []"
              outlined dense
            ></v-text-field>
            <div class="pb-4">
              Selecione os participantes que deseja incluir:
              <div class="row items-center">
                <div class="col pb-5">
                  <v-checkbox
                    label="Selecionar todos"
                    color="primary"
                    class="pa-0"
                    :value="!!(participants.length >= participantsOptions.length)"
                    @change="selectAll"
                    hide-details
                  ></v-checkbox>
                </div>
                <div class="col-auto pt-7 caption">{{ participants.length }}/{{ participantsOptions.length }}</div>
              </div>
              <div class="pa-1 my-2" style="border: 1px solid #ccc">
                <v-virtual-scroll :height="200" :itemHeight="35" :items="participantsOptions">
                  <template v-slot:default="{ item }">
                    <div class="px-2">
                      <v-checkbox
                        :key="item.value"
                        :value="item.value"
                        :label="item.text"
                        v-model="participants"
                        color="primary"
                        class="pa-0"
                        hide-details
                      ></v-checkbox>
                    </div>
                  </template>
                </v-virtual-scroll>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'joinedMultipleForm',
  components: {
    AppLoading,
    DecimalNumber
  },
  props: ['id', 'celebrationId', 'fundraisingId'],
  data: () => ({
    loading: false,
    fundraisingSettings: {},
    fields: {
      fundraising_id: {
        value: '',
        name: ''
      },
      amount_to_pay: {
        value: 0,
        rules: [
          v => !!v || 'O valor total é obrigatório'
        ],
        apiErrors: []
      },
      method: {
        value: '',
        rules: [
          v => !!v || 'A forma de pagamento é obrigatória'
        ],
        apiErrors: []
      },
      period: {
        value: '',
        rules: [
          v => !!v || 'A período é obrigatório'
        ],
        apiErrors: []
      },
      number_of_installment: {
        value: 0,
        max: 0,
        rules: [
          v => !!v || 'O número de parcelas é obrigatório'
        ],
        apiErrors: []
      }
    },
    participantsList: [],
    participants: [],
    alreadyJoined: [],
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key === 'period' && this.fields.method.value === 'monthly') data[key] = 'ALL'
        else if (this.fields[key]) data[key] = this.fields[key].value
      }
      return data
    },
    methodOptions () {
      const options = [
        { value: 'monthly', text: 'Mensal' },
        { value: 'quarterly', text: 'Trimestral' },
        { value: 'semiannual', text: 'Semestral' },
        { value: 'yearly', text: 'Anual' }
      ]
      if (this.fundraisingSettings) {
        const fundraisingOptions = Object.keys(this.fundraisingSettings)
        return options.filter(e => fundraisingOptions.includes(e.value))
      }
      return options
    },
    periodOptions () {
      let settings = {
        monthly: ['ALL'],
        quarterly: ['JAN|ABR|JUL|OUT', 'FEV|MAI|AGO|NOV', 'MAR|JUN|SET|DEZ'],
        semiannual: ['JAN|JUL', 'FEV|AGO', 'MAR|SET', 'ABR|OUT', 'MAI|NOV', 'JUN|DEZ'],
        yearly: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
      }
      if (this.fundraisingSettings && this.fundraisingSettings) {
        settings = this.fundraisingSettings
      }
      if (this.fields.method.value) {
        return settings[this.fields.method.value] || []
      }
      return []
    },
    participantsOptions () {
      return this.participantsList.filter(e => !this.alreadyJoined.includes(e.value))
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getParticipants (page) {
      this.loading = true
      axios.get('participants?page[size]=30&page[number]=' + (page || 1) + '&&filter[celebration_id]=' + this.celebrationId)
        .then(response => {
          if (!page) this.participantsList = []
          if (response.data && response.data.data) {
            for (const i in response.data.data) {
              const participant = response.data.data[i]
              this.participantsList.push({
                value: participant.id || '',
                text: (participant.customer && `${participant.customer.name || 'Sem nome'} (${participant.customer.person_document || 'Sem CPF'})`) || ''
              })
            }
          }
          if (response.data.meta.last_page > response.data.meta.current_page) {
            if (!page) this.getParticipants(2)
            else if (page < response.data.meta.last_page) this.getParticipants(page + 1)
          } else {
            this.loading = false
          }
        })
        .catch(() => {
          this.participantsList = []
        })
    },
    selectAll () {
      if (this.participants.length >= this.participantsOptions.length) {
        this.participants = []
      } else {
        this.participants = this.participantsOptions.map(e => e.value)
      }
    },
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    async send () {
      let vue = this

      if (vue.$refs.form.validate()) {

        if (this.participants.length === 0) {
          vue.errorMessage = 'Selecione pelo menos um participante'
          return
        }

        vue.sending = true
        vue.errorMessage = null

        for (const index in this.participants) {
          if (this.participants[index]) {
            await axios.post('joineds', { ...vue.apiData, participant_id: this.participants[index] })
          }
        }
        vue.sending = false
        vue.SET_SNACKBAR({ text: (vue.id) ? 'Próximos pagamentos atualizados' : 'Participante arrecadando' })
        vue.$router.go(-1)
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  created () {
    let vue = this
    vue.loading = true

    if (this.fundraisingId) {
      axios.get('fundraisings/' + vue.fundraisingId)
        .then(response => {
          if (response.data) {
            vue.fields.fundraising_id.value = vue.fundraisingId
            vue.fields.fundraising_id.name = response.data.name
            vue.fields.amount_to_pay.value = response.data.unit_price
            vue.fundraisingSettings = response.data.settings
            vue.fields.number_of_installment.value = vue.$moment(response.data.finish_date).date(5).diff(vue.$moment(), 'months') + 1
            vue.alreadyJoined = response.data.participants.map(e => e.id)

            vue.getParticipants()
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  }
}
</script>
